import router from '../router/'
import { AuthService } from '@/services/auth'

const state = {
  status: { loggedIn: true },
  token: null,
  acterror: false,
  acterrormsg: 'token exp',
  loading: false,
  drawer: true,
  is2fa: false,
  isseller: false,
  accountlengkap: true,
  syaratketentuan: false,
  user: {
    username: '',
    email: '',
    image: '',
    roles: [],
    va: [],
    verifyphone: true,
    member: {
      memberbalance: 0,
      memberavatar: '',
      membername: '',
      membercontact: '',
      memberphone: '',
      statustoko: 0
    }
  },
  isAdmin: false
}
const actions = {
  setState2fa ({ commit }, status) {
    commit('setPanel2fa', status)
  },
  stateDrawer ({ commit }) {
    commit('getDrawerstatex')
  },
  setProfileImage ({ commit }, image) {
    commit('setprofileimage', image)
  },
  register ({ dispatch, commit }, regdata) {
    commit('setloading', true)
    AuthService.registerUser(regdata)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        router.push('/login')
        dispatch('alert/success', 'Mohon check email untuk aktivasi user', { root: true })
      })
      .catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  activate ({ dispatch, commit }, token) {
    commit('setloading', true)
    AuthService.activateUser(token)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        router.push('/login')
        dispatch('alert/success', 'User activated successfully', { root: true })
      })
      .catch(error => {
        commit('setacterr', error)
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  setpass ({ dispatch, commit }, set) {
    commit('setloading', true)
    AuthService.gantipasswordsetpass(set)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        router.push('/login')
        dispatch('alert/success', 'reset password succfully', { root: true })
      })
      .catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  resetpass ({ dispatch, commit }, email) {
    commit('setloading', true)
    AuthService.forgotpassword(email)
      .then(data => {
        console.log(data)
        commit('setloading', false)
        router.push('/login')
        dispatch('alert/success', 'Reset password link terkirim ke email anda', { root: true })
      })
      .catch(error => {
        commit('setloading', false)
        dispatch('alert/error', error, { root: true })
      })
  },
  doVerifyOTPLogin ({ dispatch, commit }, code) {
    commit('setloading', true)
    console.log(code)
    AuthService.verifyOTPLogin(code).then(user => {
      commit('loginSuccess', user)
      dispatch('alert/success', 'Login Successfully', { root: true })
      dispatch('UserStore/getBalance', '', { root: true })
      AuthService.getme().then(data => {
        commit('getme', data)
        window.getApp.$emit('SOCKET_LOGON', { token: user.access_token, userid: data.data.id })
        if (data.data.member.provinceid) {
          dispatch('UtilsStore/getCity', data.data.member.provinceid, { root: true })
        }
        if (data.data.member.cityid) {
          dispatch('UtilsStore/getDistrict', data.data.member.cityid, { root: true })
        }
        router.push('/home')
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
      commit('setloading', false)
      commit('loginFailure', error)
      dispatch('alert/error', error, { root: true })
    })
  },
  updateSyaratketentuan ({ dispatch, commit }, data) {
    console.log('update syarat')
    AuthService.updateSyaratKetentuan().then(data => {
      console.log(data)
      commit('setloading', false)
      dispatch('alert/success', 'Syarat dan ketentuan berhasil diupdate', { root: true })
      dispatch('getme')
    }
    ).catch(error => {
      console.log(error)
      commit('setloading', false)
      dispatch('alert/error', error, { root: true })
    })
  },
  dologin ({ dispatch, commit }, { email, password }) {
    commit('setloading', true)
    AuthService.login(email, password).then(user => {
      if (user.fa) {
        // router.push('/verify2fa')
        commit('setloading', false)
        commit('setPanel2fa', true)
      } else {
        commit('setPanel2fa', false)
        commit('loginSuccess', user.data)
        dispatch('alert/success', 'Login Successfully', { root: true })
        dispatch('UserStore/getBalance', '', { root: true })
        AuthService.getme().then(data => {
          commit('getme', data)
          window.getApp.$emit('SOCKET_LOGON', { token: user.access_token, userid: data.data.id })
          if (data.data.member.provinceid) {
            dispatch('UtilsStore/getCity', data.data.member.provinceid, { root: true })
          }
          if (data.data.member.cityid) {
            dispatch('UtilsStore/getDistrict', data.data.member.cityid, { root: true })
          }
          router.push('/home')
        }).catch(error => {
          console.log(error)
        })
      }
    }).catch(error => {
      console.log(error)
      commit('setloading', false)
      commit('loginFailure', error)
      dispatch('alert/error', error, { root: true })
    })
  },
  getme ({ dispatch, commit }) {
    AuthService.getme().then(data => {
      commit('getme', data)
      if (data.data.member.provinceid) {
        dispatch('UtilsStore/getCity', data.data.member.provinceid, { root: true })
      }
      if (data.data.member.cityid) {
        dispatch('UtilsStore/getDistrict', data.data.member.cityid, { root: true })
      }
      if (data.data.member.adminconfirmation === 2) {
        if (data.data.member.apitest === 1) {
          dispatch('SellerStore/setstepsellerreg', 2, { root: true })
        } else {
          dispatch('SellerStore/setstepsellerreg', 3, { root: true })
        }
      } else {
        if (data.data.member.adminconfirmation === 3) {
          if (data.data.member.apitest === 1) {
            dispatch('SellerStore/setstepsellerreg', 3, { root: true })
          } else {
            dispatch('SellerStore/setstepsellerreg', 4, { root: true })
          }
        } else {
          if (data.data.member.adminconfirmation === 1) {
            dispatch('SellerStore/setstepsellerreg', 1, { root: true })
          }
        }
      }
    }).catch(error => {
      console.log('getme error')
      AuthService.logout()
      commit('loginFailure', error)
      dispatch('alert/error', error, { root: true })
      if (error.indexOf('invalid_token')) {
        router.push('/login')
      }
    })
  },

  logout () {
    AuthService.logout()
    router.push('/login')
  }
}
const mutations = {
  getDrawerstatex (state) {
    state.drawer = !state.drawer
  },
  setPanel2fa (state, data) {
    state.is2fa = data
  },
  setacterr (state, msg) {
    state.acterror = true
    state.acterrormsg = msg
  },
  setloading (state, load) {
    state.loading = load
  },
  loginSuccess (state, user) {
    console.log(user.access_token)
    state.loading = false
    state.status = { loggedIn: true }
    // state.user = { id: user.id, name: user.name };
    state.token = user.token
    localStorage.setItem('token', user.access_token)
  },
  loginFailure (state) {
    state.loading = false
    state.status = {}
    state.user = { id: null, name: null }
    state.token = null
  },
  setprofileimage (state, image) {
    state.user.member.memberavatar = image
  },
  getme (state, user) {
    //  console.log('XgetMe:' + JSON.stringify(user.data))
    state.user = {
      id: user.data.id,
      name: user.data.name,
      info: user.data.info,
      username: user.data.username,
      menu: user.data.menu,
      email: user.data.email,
      roles: user.data.roles,
      member: user.data.member,
      verifyphone: user.data.verifyphone,
      va: user.data.va,
      city: user.data.cities ? user.data.cities.cityname : null,
      province: user.data.province ? user.data.province.provincename : null
    }
    if (typeof user.data.member.memberphone === 'undefined' || user.data.member.memberphone === null) {
      user.data.member.memberphone = ''
    }
    state.accountlengkap = true // user.data.member.memberphone.length > 0
    state.syaratketentuan = user.data.member.syaratketentuan === 0
    localStorage.setItem('user', JSON.stringify(state.user))
    state.isAdmin = false
    state.isseller = false
    user.data.roles.forEach(rol => {
      if (rol.name === 'ROLE_ADMIN') {
        state.isAdmin = true
      }
      if (rol.name === 'ROLE_SELLER') {
        state.isseller = true
      }
    })
  }
}

export const authentication = {
  namespaced: true,
  state,
  actions,
  mutations
}
